import { createContext, ReactNode } from 'react'
import { Illustration } from '../illustrated-message/illustrated-message.types'
import { MantineStyleProp } from '@mantine/core'
import { ButtonShape } from '../button/button.types'

export type ColumnProps = MantineStyleProp

export type TableColumn = {
  id: string
  /** Header content. Omit to fall back to `id`; pass `''` for an unheaded column. */
  content?: React.ReactNode
  isSortable?: boolean
  props?: ColumnProps
  isSticky?: boolean
  bgColor?: string
}

export type TableColumnSortDirection = 'ASC' | 'DESC'

export type TableContextType = {
  columns: TableColumn[]
  title?: string
  totalResults: number | null
  isLoading: boolean
  tableHeadTestId?: string
  illustration: Illustration
  emptyTableTitle: string
  emptyTableDescription?: string
  emptyTableButton?: {
    label: string
    onClick: VoidFunction
  }
  emptyTableButtonShape?: ButtonShape
  handleRequestSort?: (columnKey: string) => void
  sortDirection?: TableColumnSortDirection
  sortByColumn?: string
  disableHorizontalScroll?: boolean
}

export const TableContext = createContext<TableContextType | undefined>(
  undefined
)

export type PaginationActionsProps = {
  totalResultsText?: string
  previousPage: (() => void) | null
  nextPage: (() => void) | null
  rightContent?: ReactNode
}
